module.exports = __webpack_public_path__ + "static/media/british-virgin-islands.c473db2c.png";